import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TextLink, Button } from "@vds/buttons";
import { DropdownSelect } from "@vds/selects";
import { Body, Micro } from "@vds/typography";
import { MarginSpacerM, MarginSpacerL } from "common/components/styleTag";
import { FLOWS, setCompletedPagesForHPB, setCurrentActiveStep, setCurrentFlowForHPB } from "../../../../app/ducks/GlobalSlice";
import { CalifProp65Modal } from "common/components";
import RecieveVZOffersModal from "common/components/Modals/RecieveVZOffersModal";
import MaximumDevicesModal from "../modals/MaximumDevicesModal";
import ApplyToAllRemainingLinesModal from "../modals/ApplyToAllRemainingLinesModal";
import PDPContext from "../pdpContext";
import { useDispatch, useSelector } from "react-redux";
import { Notification } from "@vds/notifications";
import PlansFirstDevicesApplyModal from "../modals/PlansFirstDevicesApplyModal";
import PlansFirstTwoYearModal from "../modals/PlansFirstTwoYearModal";
import { useMediaQuery } from "react-responsive";
import { resetCompletedPages } from "common/components/HorizontalProgress/VZStepperGetSteps";
import TypeaheadDropdown from "common/components/TypeaheadDropdown/TypeaheadDropdown";
import CountDown from "common/components/CountDown/CountDown";

const Quantity = ({
  addToCartFn,
  maxDeviceQuantity,
  showProp65Warning,
  isEditPackageFlow,
  hideQuantityDropdown,
  editPackagePackageId,
  editPackageGrpId,
  isPlanFirstFlow,
  isLTEOrCbandFlow,
  isPricingAvailable,
  isfromShoppingCart,
  plansFirstFlowNew,
  productDetail,
  isPFCategory,
  stickyHeaderContinueClick,
  isStickyButton,
  setIsDisabledQuantityNew,
  ...props
}) => {
  const { t } = useTranslation(["pdp", "app"]);
  const buePlansArr = t("app.common.buePlansArr", { ns: "app", returnObjects: true });
  const plansFirstCategories = t('plans-first.category', { ns: "app", returnObjects: true });
  const globalData = useSelector((state) => state.GlobalData);
  const pageData = useSelector((state) => state.MobilityPage);
  const planFirstPageData = useSelector((state) => state.PlanFirst);
  const preSelectedPlan = globalData?.GWPlansID;
  const preSelectedDevice = globalData?.GWDeviceType;
  const sessionCartData =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData;
  const isPDPProtectionEnabled = globalData?.metaInformation?.showProtectionFeaturesOnPDP;
  const bulkAalEnabled = globalData?.metaInformation?.bulkAalEnabled;
  const bulkAalMaxQty = globalData?.metaInformation?.bulkAalMaxQty;
   const {
    flow,
    isChangeDevice,
    selectedPayment: { selectedPayment },
    selectedQuantity: { selectedQuantity, setSelectedQuantity },
    selectedSku: { selectedSku },
    selectedPromo: { selectedPromo },
    combinePricing,
    deviceLockIndicator,
    portIn,
    portInType,
    selectedSimType: { selectedSimType },
    selectedFeature: { selectedFeature, _setSelectedFeature },
    onFeatureError,
    showPDPProtectionPlans,
    reinitiateFlow,
  } = React.useContext(PDPContext);
  const dispatch = useDispatch();
  // const [isPlaceholder, setIsPlaceHolder] = useState(true);
  const [isError, setIsError] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledQuantity, setIsDisabledQuantity] = useState(false);
  // const [showDropdown, setShowDropDown] = useState(false);
  // const [showFiltered, setShowFiltered] = useState(true);
  const [isVerizonOffer, setIsVerizonOffer] = useState(false);
  const [showMaxDeviceModal, setMaxDeviceModal] = useState(false);
  const [showProp65Modal, setShowProp65Modal] = useState(false);
  const [showAllLinesModal, setShowAllLinesModal] = useState(false);
  const [isBUPlanSelected, setIsBUPlanSelected] = useState(false);
  const [showDeviceConfirmModal, setShowDeviceConfirmModal] = useState(false);
  const [showTwoYearContractModal, setShowTwoYearContractModal] = useState(false);
  const packagesObj = sessionCartData?.cart?.packages;
  let preObrderShimentDate = selectedSku?.shipmentDate?.replace(/\b0/g, "");
  const isPlansFirst = globalData?.flow == "plans-first" ? true : false;

    const isMobile = useMediaQuery({
    query: "(max-width: 727px)",
  });

  const getAccessoryQuantity = (quan, maxQuantitySelected) => {
    let quantity = quan || 0;
    if (props.fromAccessory) {
      quantity = 0;
      const { accessories } = sessionCartData?.cart;
      if (
        accessories !== null &&
        accessories &&
        Object.keys(accessories).length
      ) {
        Object.keys(accessories).map((key) => {
          if (key !== editPackagePackageId)
            quantity += accessories[key]["quantity"];
        });
      }
      if (quan * 10 - (quantity + maxQuantitySelected) >= 0) return -1;
      else return 10 - maxQuantitySelected;
    }
    return quantity;
  };

  const addSmartPhoneToCart = (addToAllLines = false, routeToPage) => {
    let quantity = packagesObj ? Object.keys(packagesObj)?.length : 0;
    if (plansFirstFlowNew === "plans-first" && plansFirstCategories.includes(globalData.category) && pageData?.isPlansFirstCategory) {
      const pkgsOriginal = Object.entries(packagesObj || {}).filter(([key, line]) => !line?.dummy)
      quantity = pkgsOriginal?.length
    }
    let maxQuantitySelected = 1;
    let selectedPlanId = packagesObj ? Object.values(packagesObj)[0]?.plan?.pricePlanCode : 0;
    if (buePlansArr.includes(selectedPlanId)) {
      setIsBUPlanSelected(true);
    }
    if (typeof selectedQuantity === "number") {
      maxQuantitySelected = selectedQuantity;
    } else if (typeof selectedQuantity === "string") {
      maxQuantitySelected = JSON.parse(selectedQuantity.replace("+", ""));
    }
    if (
      editPackagePackageId !== null &&
      editPackagePackageId &&
      packagesObj !== null &&
      packagesObj
    ) {
      const { groupPackages } = sessionCartData.cart;
      const packageId = String(editPackagePackageId).split("_")[0];
      let exitingQuantity = 0;
      if (
        groupPackages !== null &&
        groupPackages &&
        Object.keys(groupPackages).length
      ) {
        Object.keys(groupPackages).map((key) => {
          if (key !== editPackageGrpId)
            exitingQuantity += groupPackages[key]["quantity"];
        });
      }
      quantity = exitingQuantity;
    }
    if (pageData?.deviceSelectedForExceedginCreditLimit !== null &&
      pageData?.deviceSelectedForExceedginCreditLimit &&
      packagesObj !== null &&
      packagesObj) {
      quantity -= 1;
    }
    quantity = getAccessoryQuantity(quantity, maxQuantitySelected);
    if (quantity + (hideQuantityDropdown ? 0 : maxQuantitySelected) >= maxDeviceQuantity && !props.exceededDevice && maxDeviceQuantity === 10) {
      setMaxDeviceModal(true);
    } else {
      const selectedOffers =
        selectedPromo && selectedPromo?.offerId
          ? [
            {
              offerId: selectedPromo?.offerId,
              type: selectedPromo?.promoType,
            },
          ]
          : null;
      if ((isPlanFirstFlow || flow === FLOWS.PLANFIRST) && isLTEOrCbandFlow && selectedPayment === 'twoyears' && isBUPlanSelected) {
        addToCartFn(
          selectedPayment,
          selectedQuantity,
          selectedSku,
          selectedOffers,
          selectedFeature,
          deviceLockIndicator,
          portIn,
          portInType,
          selectedSimType,
          "plans-first-lte-cband",
          addToAllLines,
          routeToPage
        );
      } else if (isPlanFirstFlow || flow === FLOWS.PLANFIRST || (plansFirstFlowNew === "plans-first" && plansFirstCategories.includes(globalData.category) && pageData?.isPlansFirstCategory && planFirstPageData?.linesRemain > 0 && selectedPayment !== 'twoyears')) {
        addToCartFn(
          selectedPayment,
          selectedQuantity,
          selectedSku,
          selectedOffers,
          selectedFeature,
          deviceLockIndicator,
          portIn,
          portInType,
          selectedSimType,
          "plans-first",
          addToAllLines,
          routeToPage
        );
      } else {
        addToCartFn(
          selectedPayment,
          selectedQuantity,
          [selectedSku],
          selectedOffers,
          selectedFeature,
          deviceLockIndicator,
          portIn,
          portInType,
          selectedSimType,
          "regular",
          addToAllLines,
          routeToPage
        );
      }
    }
  };

  useEffect(() => {
    if (stickyHeaderContinueClick) {
      onAddToCartButtonClick();
      props?.setStickyHeaderContinueClick(false);
    }
  }, [stickyHeaderContinueClick]);
  const getButtonText = (sku) => {
    if (!sku || sku?.outOfStock || props.isoutOfStock) {
      return t("device-pdp.outOfStock1");
    }else if (sku?.preOrder) {
      return t("device-pdp.preOrderCart");
    }else if (sku?.backOrder || props?.backOrder) {
      return t("device-pdp.backOrder");
    } else if (isChangeDevice || isEditPackageFlow) {
      return t("device-pdp.update");
    } else if (flow === FLOWS.PLANFIRST || (preSelectedPlan && preSelectedDevice)) {
      return t("device-pdp.next");
    } else if (props?.deviceDetails?.category === "Connected Devices" || props?.isOneTalk || props?.fromAccessory) {
      return t("device-pdp.addtocart");
    } else if (plansFirstFlowNew === 'plans-first' && plansFirstCategories.includes(globalData.category) && (pageData?.isPlansFirstCategory || isPFCategory) && planFirstPageData?.linesRemain > 0) {
      return t("device-pdp.next");
    } else return t("device-pdp.continueToPlan");
  };

  const showDevicesApplyModal = () => {
    if (!!showPDPProtectionPlans && !selectedFeature?.featureCode) {
      onFeatureError();
    } else {
      if (selectedPayment === "twoyears") {
        setShowTwoYearContractModal(true);
      } else {
        planFirstPageData?.linesRemain > 0 &&
          planFirstPageData?.linesRemain - selectedQuantity != 0
          ? setShowDeviceConfirmModal(true)
          : applyToOneLine();
      }
            
      if (!!reinitiateFlow && typeof reinitiateFlow == "function") {
        reinitiateFlow()
      }
    }
  };

  const closeDevicesApplyModal = () => {
    setShowDeviceConfirmModal(false)
  }

  const closeTwoYearModal = () => {
    setShowTwoYearContractModal(false)
  }

  const onAddToCartButtonClick = () => {
    if (!!showPDPProtectionPlans && !selectedFeature?.featureCode) {
      onFeatureError();
    } else {
      if (flow === FLOWS.PLANFIRST) {
        // TODO: check if remaining lines > 1
        const devices = Object.values(
          globalData?.sessionCartData?.devices || {}
        );
        const dummyPkgCount = devices.filter(
          (i) => i?.deviceFullDetail?.dummy
        ).length;
        if (!isChangeDevice && !isEditPackageFlow && dummyPkgCount > 1) {
          setShowAllLinesModal(true);
        } else {
          addSmartPhoneToCart();
        }
      } else addSmartPhoneToCart();
      if(!!reinitiateFlow && typeof reinitiateFlow == "function" ){
        reinitiateFlow()
        }

      if (flow !== FLOWS.PLANFIRST && globalData?.currentFlowForHPB?.includes("WithJO")) {
        setTimeout(() => {
          dispatch(setCurrentFlowForHPB(""))
          dispatch(setCompletedPagesForHPB(resetCompletedPages(globalData.completedPagedForHPB)))
          dispatch(setCurrentActiveStep(0))
        });
        
      }

    }
  };
  // const handleQuantityFocus = () =>
  //   {
  //     if(isPlaceholder)
  //       {
  //         setSelectedQuantity('');
  //         setIsPlaceHolder(false);
  //       }
  //   }

    const handleQuantityChange =(qtyvalue)=>{
      if(qtyvalue <=0 || isNaN(qtyvalue) || qtyvalue>bulkAalMaxQty)
          {
              //setQuantity('');
              setSelectedQuantity('');
              setIsError(true);
              setErrorMessage("Enter a Valid Quantity");
              setIsDisabled(true);
              return;
          } 
          else
          {
              setIsError(false);
              setErrorMessage('');
          }       
      setSelectedQuantity("");    
      let value = Number(qtyvalue);
      setSelectedQuantity(value);
      // if(value < 5)
      // {
      // setShowDropDown(true);
      // setShowFiltered(true);
      // }
      // else
      // {
      //   setShowDropDown(false);
      //   setShowFiltered(false);
      // }
  }
  // const handleOptionClick =(value) =>{
  //   setSelectedQuantity(value);
  //   setIsError(false);
  //   setShowDropDown(false);
  // }

  const applyToAllLines = () => {
    addSmartPhoneToCart(true, isPDPProtectionEnabled ? '' : 'features')
    // dispatch(setLinesRemain(0));
  };

  const applyToOneLine = () => {
    // let routePage = (planFirstPageData?.linesRemain === 0 || Number.parseInt(planFirstPageData?.linesRemain) - 1 === 0) ? 'features' : 'smartphones';
    let routePage =
      (selectedQuantity + planFirstPageData?.linesRemain >
        planFirstPageData?.linesCount) && !isPDPProtectionEnabled
        ? "features"
        : "smartphones";
    addSmartPhoneToCart(false, routePage);

    if (planFirstPageData?.linesRemain > 0) {
      // dispatch(setLinesRemain(Number.parseInt(planFirstPageData?.linesRemain) - 1));
    }
  };

  useEffect(() => {
    if (maxDeviceQuantity !== null && maxDeviceQuantity && maxDeviceQuantity < 10 && props.exceededDevice && selectedQuantity !== maxDeviceQuantity) {
      setSelectedQuantity(maxDeviceQuantity)
    }
  }, [maxDeviceQuantity])
  useEffect(()=>{
    if(selectedSku && !selectedSku.iconicDevice && isDisabledQuantity){
      setIsDisabledQuantity(false)
     if(setIsDisabledQuantityNew && typeof setIsDisabledQuantityNew == 'function') setIsDisabledQuantityNew(false)
    }
  },[selectedSku])
  const showCountDown = (selectedSku && selectedSku.iconicDevice && selectedSku.endTimeStampInTargetTimeZone) ? true : false
  return (
    <>
    {showCountDown ? 
      <CountDown isDisabledQuantity={isDisabledQuantity} toDate={new Date(new Date(selectedSku.endTimeStampInTargetTimeZone) + 'UTC')} fromPDP setDisableButton={(value) => {
          setIsDisabledQuantity(value)
          if(setIsDisabledQuantityNew && typeof setIsDisabledQuantityNew == 'function') setIsDisabledQuantityNew(value)
        }}/>:<></>}
      {props.isOneTalk ? (
        <>
          <CustomNotification
            type="info"
            title={`${t(
              "device-pdp.oneTalk.device-info.combinePricing.deskphones.headerMsg",
              { ns: "pdp" }
            )}`}
            subtitle={`${t(
              "device-pdp.oneTalk.device-info.combinePricing.deskphones.deskonetalk",

              {
                ns: "pdp",
              }
            )}`}
            fullBleed={true}
            inlineTreatment={false}
            hideCloseButton={true}
            viewport="mobile"
          />
          <MarginSpacerL />
        </>
      ) : (
        <></>
      )}
      {selectedSku?.preOrder && (
        <StyledPreOrderText isStickyButton={isStickyButton}>
        <Body bold size="medium" className="title">
          {t("device-pdp.PreOrderEstimatedDate", {
            ns: "pdp",
            shippingDate: preObrderShimentDate,
          })}
          </Body>
          </StyledPreOrderText>
      )}
      {!isfromShoppingCart && <MarginSpacerL />}
      {props.deviceDetails !== null &&
        props.deviceDetails &&
        Object.keys(props.deviceDetails).length > 0 &&
        t("disclaimer", { returnObjects: true })[
        props.deviceDetails.deviceId
        ] && (
          <>
            <Body bold size="medium" className="title">
              <span
                dangerouslySetInnerHTML={{
                  __html: `${t("disclaimer", { returnObjects: true })[
                    props.deviceDetails.deviceId
                    ]["message"]
                    }`,
                }}
              ></span>
            </Body>
            <MarginSpacerL />
          </>
        )}
      {hideQuantityDropdown ? "" : <Font12>{t("device-pdp.quantity")}</Font12>}

      <AddCartContainer className="add-cart-wrapper" isMobile={isMobile}>
        {hideQuantityDropdown ? (
          ""
        ) : bulkAalEnabled ? (
          <TypeaheadDropdown
            width={"82px"}
            type="number"
            maxLength={2}
            data={Array.from({ length: bulkAalMaxQty }, (_, i) => i + 1)}
            value={selectedQuantity}
            onChange={(value) => handleQuantityChange(value)}
            error={isError}
            errorText={ErrorMessage}
            showDropdownForSingleOption={false}
          />
        ) : (
          <DropdownSelect
            disabled={maxDeviceQuantity < 10}
            width={"82px"}
            className="numLines-dropdownSelect"
            onChange={(e) => {
              setSelectedQuantity(Number(e.target.value));
              // reinitiateFlow()
            }}
            value={selectedQuantity}
          >
            {Array.apply(0, Array(maxDeviceQuantity)).map((_, b) => (
              <option key={b + 1} value={b + 1}>
                {b + 1}
                {b + 1 === maxDeviceQuantity &&
                !props.fromAccessory &&
                maxDeviceQuantity === 10
                  ? "+"
                  : ""}
              </option>
            ))}
          </DropdownSelect>
        )}
        <StyledButton
          data-polymap={getButtonText(selectedSku)}
          size="large"
          isfromShoppingCart={isfromShoppingCart}
          isStickyButton={isStickyButton}
          onClick={
            plansFirstFlowNew === "plans-first" &&
            plansFirstCategories.includes(globalData.category) &&
            (pageData?.isPlansFirstCategory || isPFCategory) &&
            planFirstPageData?.linesRemain > 0
              ? showDevicesApplyModal
              : onAddToCartButtonClick
          }
          data-track="Add to cart"
          disabled={
            isDisabledQuantity ||
            pageData?.disableAddToCart ||
            !selectedSku ||
            selectedSku?.outOfStock ||
            props.isoutOfStock ||
            (!props?.fromAccessory && !isPricingAvailable)
          }
        >
          {getButtonText(selectedSku)}
        </StyledButton>
      </AddCartContainer>
      {isMobile && !isPlansFirst && !isfromShoppingCart && (
        <StickyWrapper className={isPlansFirst ? "" : "plansFlow"}>
          {hideQuantityDropdown ? (
            ""
          ) : (
            <Font12>{t("device-pdp.stickyHeaderQuantity")}</Font12>
          )}
       
          <AddCartContainer className="add-cart-wrapper" isMobile={isMobile} style={{paddingLeft:"12px"}}>
            {hideQuantityDropdown ? (
              ""
            ) : (
              <DropdownSelect
                disabled={maxDeviceQuantity < 10}
                width={"82px"}
                className="numLines-dropdownSelect"
                onChange={(e) => setSelectedQuantity(Number(e.target.value))}
                value={selectedQuantity}
              >
                {Array.apply(0, Array(maxDeviceQuantity)).map((_, b) => (
                  <option key={b + 1} value={b + 1}>
                    {b + 1}
                    {b + 1 === maxDeviceQuantity &&
                      !props.fromAccessory &&
                      maxDeviceQuantity === 10
                      ? "+"
                      : ""}
                  </option>
                ))}
              </DropdownSelect>
            )}
            <StyledButton
              data-polymap={getButtonText(selectedSku)}
              size="large"
              isfromShoppingCart={isfromShoppingCart}
              onClick={
                plansFirstFlowNew === "plans-first" &&
                  plansFirstCategories.includes(globalData.category) &&
                  (pageData?.isPlansFirstCategory || isPFCategory) &&
                  planFirstPageData?.linesRemain > 0
                  ? showDevicesApplyModal
                  : onAddToCartButtonClick
              }
              data-track="Add to cart"
              disabled={
                isDisabledQuantity || 
                pageData?.disableAddToCart ||
                !selectedSku ||
                selectedSku?.outOfStock ||
                props.isoutOfStock ||
                (!props?.fromAccessory && !isPricingAvailable)
              }
              style={{width:"200px", padding:"0px"}}
            >
              {getButtonText(selectedSku)}
            </StyledButton>
          </AddCartContainer>

        </StickyWrapper>
      )}
      <Links>
        {!props.isOneTalk && (
          <Micro>
            <TextLink
              className="device-info"
              onClick={() => setIsVerizonOffer(true)}
            ></TextLink>
          </Micro>
        )}
      </Links>
      {isVerizonOffer && <RecieveVZOffersModal opened={isVerizonOffer} />}
      {showMaxDeviceModal && (
        <MaximumDevicesModal
          deviceQuantity={maxDeviceQuantity}
          opened={showMaxDeviceModal}
          onOpenedChange={setMaxDeviceModal}
        />
      )}
      {showProp65Modal && (
        <CalifProp65Modal
          opened={showProp65Modal}
          onOpenedChange={setShowProp65Modal}
        />
      )}
      {showAllLinesModal && (
        <ApplyToAllRemainingLinesModal
          opened={showAllLinesModal}
          onOpenedChange={setShowAllLinesModal}
          onClickContinue={addSmartPhoneToCart}
        />
      )}
      {showDeviceConfirmModal && (
        <PlansFirstDevicesApplyModal
          showModal={true}
          linesCount={planFirstPageData.linesCount}
          linesRemain={planFirstPageData.linesRemain}
          selectedQuantity={selectedQuantity}
          applyToAllLines={applyToAllLines}
          applyToOneLine={applyToOneLine}
          addSmartPhoneToCart={addSmartPhoneToCart}
          closeModal={closeDevicesApplyModal}
        />
      )}
      {showTwoYearContractModal && (
        <PlansFirstTwoYearModal
          showModal={true}
          closeModal={closeTwoYearModal}
          continueTwoYearDevice={addSmartPhoneToCart}
        />
      )}
      {!isStickyButton && <MarginSpacerM />}
    </>
  );
};

const AddCartContainer = styled.div`
  display:flex;
  align-items:center;
`;
const StyledButton = styled(Button)`
  display: flex;
  margin-left: ${({ isfromShoppingCart }) => (isfromShoppingCart ? "0rem" : "1rem")};
  width: ${({ isStickyButton }) => (isStickyButton ?"fit-content":"240px")};
  span {
    font-size: 16px;
  }
  @media screen and (max-width: 768px) {
    flex-grow: 1;
  }
`;
const Links = styled.div`
  padding-top: 0rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;
const CustomNotification = styled(Notification)`
  div[type="info"] {
    border-radius: 4px;
  }
`;
const Font12 = styled.div`
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  font-family: "Verizon-NHG-eTX";
`;
const StickyWrapper = styled.div`
 @media screen and (max-width: 767px) {
left:0;
padding:1rem;
}
&.plansFlow{
  @media screen and (max-width: 767px) {
  bottom: 0px;
    background-color: white !important;
    z-index: 100;
    position: fixed !important;
    height: 5rem;
    display:flex;
    align-items:center;
    width:100%;
}
}
`;

const StyledPreOrderText = styled.div`
 ${({ isStickyButton }) => isStickyButton && `
 [class^="StyledTypography-VDS"]{
 padding-bottom:10px;
}
 `}
`
export default React.memo(Quantity);
